export enum UserType {
  captive = 'captive', // works for one insurance company
  nonCaptive = 'non-captive', // works for an agency
}
